<script setup lang="ts">
import { Incident } from '@collector/sportsapi-types'

import { useIncidentStyle } from './useIncidentStyle'

interface Props {
  incident: Incident
  incidentName: string
  isDeleted: boolean
}
defineProps<Props>()

const { getIncidentTextClasses } = useIncidentStyle()
</script>

<template>
  <div
    class="text-xs @[15rem]/history-incident:text-sm"
    :class="[
      getIncidentTextClasses(incident, isDeleted),
      { 'line-through': isDeleted },
    ]"
  >
    {{ incidentName }}
  </div>
</template>
